const resolveComponent = (value: any, context: any) => (typeof value === "function" ? value(context) : value);

export { resolveComponent };
